import { render, staticRenderFns } from "./penalty-detail.vue?vue&type=template&id=292e6590&scoped=true"
import script from "./penalty-detail.vue?vue&type=script&lang=js"
export * from "./penalty-detail.vue?vue&type=script&lang=js"
import style0 from "./penalty-detail.vue?vue&type=style&index=0&id=292e6590&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "292e6590",
  null
  
)

export default component.exports